import * as React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import BarkprintsTable from "../components/Tables/BarkprintsTable";
import PageTitles from "../components/Layout/PageTitles";

export default function Barkprints() {
  return (
    <>
      <PageTitles title={"View Barkprints"} />
      <Grid id="i" container spacing={3} direction="row">
        <Grid item id="j" xs>
          <Grid item id="k" sx={{ mb: 3 }}>
            <Paper
              id="l"
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                height: "auto",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <BarkprintsTable />
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
